
export class ElementoNPModel {
  Guid: string = '';
  Id: number = 0;
  Empresa: number = 0;
  Nombre: string = '';
  Lat: number = 0;
  Lng: number = 0;
  IdEquipamiento: number = 0;
  FechaCreacion: Date;
  FechaModificacion: Date;
  FechaBaja: Date;
  public ImeiVolum: string;
  public UltFechaVolum: Date;
  public UltLecturaVolum: number;
  public UltPctjeVolum: number;
  public UltBateriaVolum: number;
  public UltTempVolum: number;
  public IdConfigVolum: number;
  public IdEcoSAT: number;
  public IdVolumetrico: string;
  public RequiereVolum: boolean;
  public EstadoInstalVolum: number;
  public Calle: string;
  public CodigoPostal: string;
  public Provincia: string;
  public ComunidadAutonoma: string;
  public Municipio: string;
  public Poblacion: string;
  public NumeroCalle: string;
  public Pais: string;

  constructor(empresa: number, nombre: string, lat: number, lng: number, idEquipamiento: number, guid: string,
    imeiVolum: string, ultFechaVolum: Date, ultLecturaVolum: number, ultPctjeVolum: number,
    ultBateriaVolum: number, ultTempVolum: number, idConfigVolum: number, idEcoSAT: number,
    idVolumetrico: string, requiereVolum: boolean, estadoInstalVolum: number,
    calle: string, codigoPostal: string, provincia: string, comunidadAutonoma: string,
    municipio: string, poblacion: string, numeroCalle: string, pais: string
  ) {
    this.Empresa = empresa;
    this.Nombre = nombre;
    this.Lat = lat;
    this.Lng = lng;
    this.IdEquipamiento = idEquipamiento;
    this.Guid = guid;
    this.ImeiVolum = imeiVolum;
    this.UltFechaVolum = ultFechaVolum;
    this.UltLecturaVolum = ultLecturaVolum;
    this.UltPctjeVolum = ultPctjeVolum;
    this.UltBateriaVolum = ultBateriaVolum;
    this.UltTempVolum = ultTempVolum;
    this.IdConfigVolum = idConfigVolum ? idConfigVolum : 0;
    this.IdEcoSAT = idEcoSAT;
    this.IdVolumetrico = idVolumetrico;
    this.RequiereVolum = requiereVolum;
    this.EstadoInstalVolum = estadoInstalVolum;
    this.Calle = calle;
    this.CodigoPostal = codigoPostal;
    this.Provincia = provincia;
    this.ComunidadAutonoma = comunidadAutonoma;
    this.Municipio = municipio;
    this.Poblacion = poblacion;
    this.NumeroCalle = numeroCalle;
    this.Pais = pais;
  }
}
